import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTimeZoneService } from "@/components/timezones/timeZoneService";
import { formatDateTime } from "./lib/format";
/** {scope} · Data through {time} ({zone}) ··· {requirement IDs} */
export function MonitoringFooter(_a) {
    var scopeLabel = _a.scopeLabel, snapshot = _a.snapshot, timeZone = _a.timeZone, requirements = _a.requirements;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var service = useTimeZoneService();
    var through = snapshot
        ? t("monitoring.footer.dataThrough", {
            time: formatDateTime(snapshot.as_of, timeZone, i18n.language),
            timeZone: service.zoneLabel(timeZone, service.text, new Date(snapshot.as_of)),
        })
        : t("monitoring.header.notUpdated");
    return (_jsxs(Stack, { direction: { xs: "column", sm: "row" }, justifyContent: "space-between", spacing: 1, component: "footer", children: [_jsx(Typography, { variant: "caption", color: "text.secondary", children: [scopeLabel, through].filter(Boolean).join(" · ") }), requirements.length ? (_jsx(Typography, { variant: "caption", color: "text.secondary", children: requirements.join(", ") })) : null] }));
}
